import { render, staticRenderFns } from "./informationsClient.vue?vue&type=template&id=15881c7c"
import script from "./informationsClient.vue?vue&type=script&lang=js"
export * from "./informationsClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports